/**
 * GAME STATE MACHINE — explicit valid transitions for game flow.
 */

const VALID_TRANSITIONS = {
  start: ["fall", "shake"],
  fall: ["transition"],
  transition: ["shake", "fall"],
  shake: ["fall", "transition"],
};

export function GameStateMachine(initialState) {
  this.state = initialState || "start";
}

GameStateMachine.prototype.canTransitionTo = function (newState) {
  var allowed = VALID_TRANSITIONS[this.state];
  return allowed && allowed.indexOf(newState) !== -1;
};

GameStateMachine.prototype.transitionTo = function (newState) {
  if (!this.canTransitionTo(newState)) {
    console.warn("GameStateMachine: invalid transition", this.state, "->", newState);
    return false;
  }
  this.state = newState;
  return true;
};

GameStateMachine.prototype.getState = function () {
  return this.state;
};

GameStateMachine.prototype.is = function (state) {
  return this.state === state;
};
